import React from "react";

import { showDialogAsync } from "../../dialog-queue";
import { AlertDialog } from "../../dialog/alert";
import { labels } from "./labels";

export const showInfoDialogAsync = ({ messageHtml }: { messageHtml: string }) =>
	showDialogAsync<boolean>(({ resolve }, { isOpen }) => (
		<AlertDialog
			titleLabel={labels.title}
			messageHtml={messageHtml}
			isOpen={isOpen}
			okLabel={labels.close}
			onOk={() => resolve(true)}
		/>
	));
